import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=52a65828&scoped=true&"
import script from "./realtime.vue?vue&type=script&lang=ts&"
export * from "./realtime.vue?vue&type=script&lang=ts&"
import style0 from "./realtime.vue?vue&type=style&index=0&id=52a65828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a65828",
  null
  
)

export default component.exports